export function ComingNext({ icon: Icon, eyebrow, title, description, testId }) {
  return (
    <section data-testid={testId} className="mw-rise">
      <p className="mw-eyebrow">{eyebrow}</p>
      <h1 className="mt-3 font-serif text-4xl tracking-tight sm:text-5xl">{title}</h1>
      <div data-testid="coming-next-empty-state" className="mt-10 rounded-lg border border-dashed border-border bg-card/60 px-6 py-14 sm:px-12">
        <div className="flex h-11 w-11 items-center justify-center rounded-md border border-border bg-background">
          <Icon className="h-5 w-5 text-gold" aria-hidden="true" />
        </div>
        <p className="mw-eyebrow mt-8">Coming next</p>
        <p className="mt-3 max-w-xl text-sm leading-relaxed text-foreground/80 sm:text-base">{description}</p>
        <p className="mt-6 text-xs text-muted-foreground">Nothing has been set up here yet. This section will open in an upcoming release.</p>
      </div>
    </section>
  );
}
